import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Pipe({ name: 'shiftTimingDisplay' })
export class ShiftTimingDisplayPipe implements PipeTransform {
  constructor(private authService: AuthService) {}

  transform(code: string | null | undefined): string {
    if (code == null || code === '') {
      return '–';
    }
    try {
      const shiftTimings: { tag: string; friendly_name: string }[] =
        this.authService.getStaticData('SHIFT_TIMINGS') || [];
      const item = shiftTimings.find((s) => s.tag === code);
      return item ? item.friendly_name : code;
    } catch {
      return code;
    }
  }
}
